export const NO_EMAIL_OWNER = 'unassigned'
